import { configureTestId } from '@jablotron/lib.spa-core/testing';
import merge from 'lodash.merge';
import type { EnvironmentConfig } from '../../server/config/interfaces';
import { parseEnvironmentConfig } from '../../server/config/interfaces';
import { isLocal } from '~/utils/isLocal';

export type { EnvironmentConfig } from '../../server/config/interfaces';

export type Config = EnvironmentConfig;

export const config = {} as Config;

export const applyEnvironmentConfig = (environmentConfig: EnvironmentConfig): void => {
  merge(config, environmentConfig);
  configureTestId(() => config.debug === true);
};

export const loadEnvironmentConfig = async (): Promise<EnvironmentConfig> => {
  const base = import.meta.env.VITE_BASE_NAME ?? '';
  const environment = isLocal ? 'development' : undefined;
  const configUrl = environment ? `${base}/config.json?environment=${environment}` : `${base}/config.json`;
  const response = await fetch(configUrl);

  if (!response.ok) {
    throw new Error(`Failed to load environment config (${response.status})`);
  }

  const environmentConfig = parseEnvironmentConfig(await response.json());
  applyEnvironmentConfig(environmentConfig);

  return environmentConfig;
};
